import {BaseObject} from './BaseObject';
import {DocumentCompany} from './DocumentCompany';
import {DocumentType} from './DocumentType';
import {DocumentCompanyAccount} from './DocumentCompanyAccount';
import {Customer} from './Customer';
import {PaymentTypeEntity} from './PaymentType';
import {DocumentItem} from './DocumentItem';

export class Vat extends BaseObject {

    id: number;
    rate: number;
    name: string;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/Vat.ts